import { gql } from "@apollo/client";

export const GET_PAYMENT_CONFIG = gql`
  query GetPaymentConfig {
    storeConfig {
      store_code
      payment_redirector_url
      payment_app_name
      payment_app_pass
      payment_merchant_id
      payment_validation_url
      payment_transaction_type
      payment_lang
      payment_account_type
      __typename
    }
  }
`;

export const ORDER_CONFIRMATION = gql`
  query OrderInformation($orderId: String!) {
    orderInformation(input: { orderId: $orderId }) {
      etax_api_is_success
      order_id
      fe_info
      payment_date
      trial_days
      contract_length
      no_attorney
      sub_total
      sub_total_with_discount
      discount_amount
      tax_amount
      grand_total
      ln_sl_subscription_type
      masked_cc_number
      payment_card_expiration
      payment_card_type
      subscription_type
      modules_allowed
      number_fee_earners
      purchaser_email
      trial_message
      trial_cancelation_message
      ln_job_title
      billing {
        name
        street
        city
        region
        country
        postcode
        telephone
        fax
        company
        __typename
      }
      items {
        sku
        title
        price
        short_discription
        ln_sl_inclusion_overview
        feature_list_pdf
        __typename
      }
      __typename
    }
  }
`;
